// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".active[data-v-392a8606] {\n  background: var(--main-light-blue);\n}\n.drop-down svg[data-v-392a8606] {\n  color: var(--main-gray-5);\n}\n.dragover[data-v-392a8606] {\n  background: var(--main-light-blue);\n  color: var(--main-blue-3);\n  -webkit-box-shadow: inset 0 0 0 2px var(--main-blue-3);\n          box-shadow: inset 0 0 0 2px var(--main-blue-3);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
